import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm, SubmitHandler } from 'react-hook-form';
import Input from "../../../components/elements/form/input";
import Button from '../../../components/elements/button';
import toast from 'react-hot-toast';
import { useAppLoader } from '../../../_common/pageLoader/appLoaderHook';
import { useFacilitiesApi } from '../../../store/api/hooks/facilitiesApiHook';

interface UserGrowerFormProps {
    _ref?: any;
    editData?: any;
    onCreate?: () => void;
    onCancel?: () => void;
}

type UserGrowerFormValueType = {
    name: string;
    phone: string;
    email: string;
};

const CreateMasterGrower: React.FC<UserGrowerFormProps> = ({ _ref, editData, onCreate = () => { }, onCancel = () => { } }) => {
    const { control, handleSubmit, setValue, reset, formState: { errors }, watch } = useForm<UserGrowerFormValueType>({
        defaultValues: {
            name: '',
            phone: '',
            email: ''
        }
    });

    const { showLoader, hideLoader } = useAppLoader();
    const facilityApi = useFacilitiesApi();

    const formReset = () => {
        reset({
            name: '',
            phone: '',
            email: ''
        });
    };

    const onSubmit: SubmitHandler<UserGrowerFormValueType> = formData => {
        showLoader();
        
        const payload = {
            name: formData.name,
            email: formData.email,
            phone: formData.phone,
            ...(editData && { teamID: editData.teamID })
        };

        facilityApi.saveTeam(
            payload,
            (response: any) => {
                hideLoader();
                const action = editData ? 'updated' : 'created';
                toast.success(`Grower ${action} successfully`);
                onCreate();
                onCancel();
                formReset();
            },
            (error: any) => {
                hideLoader();
                toast.error(error || 'Failed to save Grower');
            }
        );
    };

    useEffect(() => {
        if (_ref?.current) {
            _ref.current.reset = formReset;
        }
    }, [_ref]);

    useEffect(() => {
        if (editData == null) {
            formReset();
        }
    }, [editData]);

    useEffect(() => {
        if (editData) {
            setValue('name', editData.name || '');
            setValue('phone', editData.phone || '');
            setValue('email', editData.emailID || editData.email || '');
        } else {
            formReset();
        }
    }, [editData]);

    return (
        <form onSubmit={handleSubmit(onSubmit)} ref={_ref} className="flex flex-col h-full">
            <div className="flex-1 overflow-auto">
                <Controller
                    name="name"
                    control={control}
                    rules={{ required: "Grower Name is required" }}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label="Grower Name"
                            type="text"
                            value={value}
                            onChange={onChange}
                            required
                            error={errors.name?.message}
                        />
                    )}
                />
            
                <Controller
                    name="phone"
                    control={control}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label="Phone Number"
                            type="text"
                            value={value}
                            onChange={onChange}
                            placeholder="+1 (555) 123-4567"
                        />
                    )}
                />
           
                <Controller
                    name="email"
                    control={control}
                    rules={{
                        pattern: {
                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                            message: "Invalid email address"
                        }
                    }}
                    render={({ field: { value, onChange } }) => (
                        <Input
                            label="Email"
                            type="email"
                            value={value}
                            onChange={onChange}
                            placeholder="example@grower.com"
                            error={errors.email?.message}
                        />
                    )}
                />
            </div>

            <div className="flex justify-end gap-2 flex-shrink-0 pt-2 border-t border-gray-200">
                <Button type="button" theme="secondary" onClick={formReset}>
                    Reset
                </Button>
                <Button type="submit">
                    Save
                </Button>
            </div>
        </form>
    );
};

export default CreateMasterGrower;